<template>
<button
  v-if="$can('all.tickets.documents.print')"
  @click="handleClick()"
  class="btn btn-fill btn-wd btn-success btn-block btn-router"
>
  <span v-if="eligibleNotWinners">
    Download CSV Reservas
  </span>
  <span v-else>
    Download CSV Ganhadores
  </span>
</button>
</template>

<script>
import downloadJs from 'downloadjs'
import { mapGetters } from 'vuex'
export default {
  name: 'btn-csv-winners',

  props: {
    eligibleNotWinners: {
      default: false
    }
  },
  computed: {
    ...mapGetters('tickets', {
      ticketsWinners: 'winners',
      elegibleNotWinner: 'elegibleNotWinner'
    }),
    ...mapGetters('customers', {
      customers: 'modelById'
    })
  },

  methods: {
    handleClick () {
      if (this.eligibleNotWinners) {
        let customers = this.elegibleNotWinner.slice(0, 20)
        this.csvExport(customers)
      } else {
        this.csvExport(this.ticketsWinners)
      }
    },
    csvExport (tickets) {
      let customers = []

      for (let id in tickets) {
        customers.push({
          uc: this.customers[tickets[id].customerId].uc,
          nome: this.customers[tickets[id].customerId].holder,
          cpf: this.customers[tickets[id].customerId].cpf,
          confirmado: ''
        })
      };

      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent += [
        Object.keys(customers[0]).join(';'),
        ...customers.map(item => Object.values(item).join(';'))
      ]
      .join('\n')
      .replace(/(^\[)|(\]$)/gm, '')

      const data = encodeURI(csvContent)
      let fileName = this.eligibleNotWinners ? 'Reservas' : 'Ganhadores'
      downloadJs(data, fileName, 'text/csv')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnCsvWinners.vue